import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=67975c3a&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=ts&"
export * from "./TableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=67975c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67975c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VSimpleTable,VTooltip})
